<template>
    <div>

        <CRow>
            <CCol md="12">
                <CCard>
                    <CCardHeader>
                        <CRow>
                            <CCol>
                                <strong>{{$t('RequestedPurchaseList')}}</strong>
                            </CCol>
                            <CCol  style="text-align: end;">
                                <!--                <CButton @click="AddAllRefer()" size="sm" color="primary">-->
                                <!--                  {{ $t('components.referSelected') }}-->
                                <!--                </CButton>-->
                            </CCol>

                        </CRow>
                        <CRow>
                            <CCol col="3">
                                <date-picker
                                        :label="$t('components.startDate')"
                                        v-model="start_date"></date-picker>
                            </CCol>
                            <CCol col="3">
                                <date-picker
                                        :label="$t('components.endDate')"
                                        v-model="end_date"></date-picker>

                            </CCol>

                        </CRow>

                    </CCardHeader>
                    <CCardBody>


                        <CDataTable
                                :items="items_buy"
                                :fields="fields"
                                column-filter
                                :items-per-page="20"
                                hover
                                @row-clicked="table_row_clicked"

                                sorter
                                pagination
                        >
                            <template #row="{item,index}">

                                <td>
                                    <p >{{ index + 1 }}</p>

                                </td>

                            </template>

                            <template #createdAt="{item}">

                                <td>
                                    {{ get_date(item.createdAt) }}

                                </td>


                            </template>
                            <template #supplierName="{item}">

                                <td>
                                    {{item.supplierName}}
                                    {{item.supplierPhone}}

                                </td>


                            </template>
                            <template #orderDate="{item}">

                                <td>
                                    {{ get_date(item.createdAt) }}

                                </td>


                            </template>

                            <template #price="{item}">

                                <td>
                                    <p style="float: right" >{{ get_currency(get_total_price(item)) }}</p>
                                </td>


                            </template>

                            <template #select-header="{item}">
                                <input type="checkbox" v-model="check_all_exit"
                                />
                            </template>
                            <template #select="{item}">
                                <td>
                                    <input type="checkbox" ref="permissions[]" v-model="id_checkbox_items"
                                           :value="item.masterId"/>
                                </td>
                            </template>


                        </CDataTable>

                    </CCardBody>

                </CCard>
            </CCol>
        </CRow>

        <CModal
                :show.sync="show_factor_detail"
                :no-close-on-backdrop="true"
                :centered="true"
                :title="$t('InventoryBill')"
                size="lg"
                color="dark"
        >
            <CCard id="printMe" v-if="selected_factor.length">
                <CCardHeader>
                    <CRow>

                        <CCol col="4" style="text-align: right">
                            <strong style="text-align: right">
                                {{ $t('components.number') }}: {{ selected_master.masterCode }}</strong>

                        </CCol>

                        <CCol col="4" class="text-center">
                            <strong style="text-align: center">
                                {{$t('supplier')}} : {{ selected_master.supplierName }} {{ selected_master.supplierPhone
                                }}</strong>
                        </CCol>

                        <CCol col="4" style="text-align: left">
                            <strong>
                                {{ $t('components.date') }} : {{ get_date(selected_master.createdAt) }}</strong>
                        </CCol>
                        <!--            <CCol col="3" style="text-align: left">-->
                        <!--              <CImg :src="VUE_APP_LOGO" width="100px" height="50px"/>-->
                        <!---->
                        <!--            </CCol>-->
                    </CRow>

                </CCardHeader>
                <CCardBody>

                    <hr class="mt-0">

                    <CCardHeader style="text-align: right">
                        <strong>{{ $t('components.documentProducts') }}</strong>
                    </CCardHeader>


                    <CDataTable
                            :items="selected_factor"
                            :fields="factor_product_fields"
                            striped
                            border
                            :items-per-page="200"
                            hover
                            pagination
                    >
                        <template #row="{item,index}">

                            <td>
                                <strong >{{ index + 1 }}</strong>

                            </td>

                        </template>
                        <template #name="{item}">

                            <td>
                                <strong >{{ item.productName }}</strong>

                            </td>

                        </template>

                        <template #qty="{item}">
                            <td>
                                <strong >{{ Math.abs(item.qty) }}</strong>
                            </td>
                        </template>

                        <template #price="{item}">
                            <td>
                                <CInput class="m-0 p-0" v-model="item.price"/>
                            </td>
                        </template>

                        <template #off="{item}">
                            <td>
                                <CInput class="m-0 p-0" v-model="item.off"/>
                            </td>
                        </template>

                        <template #vat="{item}">
                            <td>
                                <CInput class="m-0 p-0" v-model="item.vat"/>
                            </td>
                        </template>
                        <template #totalPrice="{item}">

                            <td>
                                <strong style="float: right" >{{get_currency(item.price*item.qty)}} </strong>

                            </td>

                        </template>

                        <template #summary="{item}">

                            <td>
                                <strong >{{ item.summary }}</strong>

                            </td>

                        </template>


                    </CDataTable>
                    <CRow>
                        <CCol col="4"></CCol>
                        <CCol col="4"></CCol>
                        <CCol col="4">
                            <CDataTable
                                    :items="document_result_price"
                                    :fields="fields_total_price"
                                    striped
                                    border
                                    :items-per-page="200"
                                    hover
                                    pagination
                            >
                                <template #resultTitle="{item}">

                                    <td>
                                        <strong >{{ item.resultTitle }}</strong>

                                    </td>


                                </template>
                                <template #resultPrice="{item}">

                                    <td>
                                        <strong >{{ item.resultPrice }}</strong>
                                        <!--                    <strong > {{VUE_APP_Currency}}</strong>-->

                                    </td>

                                </template>

                            </CDataTable>

                        </CCol>
                    </CRow>


                </CCardBody>

            </CCard>


            <template #footer>
                <!--        <CCol col="5">-->
                <date-picker v-if="selected_master.supplierPaymentType!= null && selected_master.supplierPaymentType!=0"
                             :label="$t('payDate')"
                             v-model="pay_date"></date-picker>
                <!--        </CCol>-->
                <CButton
                        color="secondary"
                        @click="accept_factor"
                >{{$t('dialogs.ok')}}
                </CButton>
                <CButton
                        @click="show_factor_detail = false"
                        color="success"
                >{{ $t("buttons.close") }}
                </CButton>
            </template>
        </CModal>

    </div>

</template>

<script>
    import axios from "axios";
    import {bus} from '../../../main';
    import Treeselect from '@riophae/vue-treeselect'
    // import the styles
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import {ASYNC_SEARCH} from '@riophae/vue-treeselect'
    import moment from 'moment-jalaali'
    import Vue from "vue";

    var simulateAsync=null
    const simulateAsyncOperation = fn => {
        if(simulateAsync!=null){
            clearTimeout(simulateAsync)
        }
        simulateAsync =  setTimeout(fn, 1000)
    }
    var items_data = [];


    export default {
        name: 'Login',
        components: {
            Treeselect,
            'test-dynamic': () => import('../documents/PrintDocument'),

        },
        data() {
            return {
                confirm_delete_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,
                // show_document: 'test-dynamic',
                printed_doc_id: 0,
                name: '',
                show_factor_detail: false,
                check_all_exit: false,

                start_date: '',
                pay_date: '',
                end_date: '',
                submit_refer: 0,
                refer_person: null,
                selected_template: 0,
                id_checkbox_items: [],
                item_sell_array: [],
                items_buy: [],
                selected_factor: [],
                selected_master: {},
                factor_product_fields: [
                    {key: 'row', label: this.$t('tables.sharp'), _style: 'width:2%'},
                    {key: 'productName', label: this.$t('components.productName'), _style: 'width:20%'},
                    {key: 'placeName', label: this.$t('inventory') , _style: 'width:15%'},
                    {key: 'qty', label: this.$t('tables.qty'), _style: 'width:5%'},
                    {key: 'price', label:this.$t('tables.amount')  , _style: 'width:10%'},
                    {key: 'off', label:this.$t('tables.off') , _style: 'width:10%'},
                    {key: 'vat', label: "VAT", _style: 'width:10%'},
                    {key: 'totalPrice', label: this.$t('tables.totalPrice'), _style: 'width:10%'},
                    {key: 'summary', label: this.$t('tables.summary'), _style: 'width:15%'},
                ],
                fields: [
                    {key: 'row', label: this.$t('tables.sharp'), _style: 'width:2%'},
                    {key: 'createdAt', label: this.$t('submitDate'), _style: 'width:15%'},
                    {key: 'masterCode', label: this.$t('orderId') , _style: 'width:10%'},
                    {key: 'supplierName', label: this.$t('supplierName'), _style: 'width:15%'},

                    {key: 'price', label: this.$t('orderAmount'), _style: 'width:15%'},
                    {key: 'orderDate', label: this.$t('orderDate'), _style: 'width:15%'},

                    // {key: 'select', label: "", _style: 'width:3%', filter: false},
                ],
                fields_total_price: [
                    {key: 'resultTitle', label: this.$t('tables.name'), _style: 'padding:5px;display:none'},
                    {key: 'resultPrice', label: this.$t('tables.price'), _style: 'padding:5px;display:none'},

                ],
                table_clicks: 0,
                table_clicks_timer: null,
                details: [],

                status_form: 0,
                load_persons({action, searchQuery, callback}) {

                    if (action === ASYNC_SEARCH) {
                        simulateAsyncOperation(() => {
                            let options;
                            const formData = new FormData();

                            formData.append('SearchTxt', searchQuery);
                            var url = "GetAllPersons";

                            formData.append('IsVendor', true);
                            formData.append('IsWorker', false);
                            formData.append('IsCustomer', false);
                            formData.append('IsActive', 0);

                            axios.post(url, formData, {show_pros: true}).then(function (response) {
                                options = response.data.data;

                                callback(null, options);

                            })
                                .catch(function (error) {

                                    console.log(error);
                                });

                        })
                    }
                },
                normalizer_persons(node) {
                    return {
                        id: node.userId,
                        label: node.personCode +" "+ node.userName +" "+ node.surName+" "+ node.mobileNo,
                    }
                },

            }
        },
        computed: {
            document_result_price: function () {
                var array = []
                var total_price = 0;
                for (var i = 0; i < this.selected_factor.length; i++) {
                    total_price = total_price + (this.selected_factor[i].price * this.selected_factor[i].qty);
                }
                var obj = {
                    resultTitle: this.$t('totalSum'),
                    resultPrice: total_price
                };
                array.push(obj)
                return array
            }
        },
        mounted() {

            this.start_date = this.get_day_before_today(1);
            this.end_date = this.get_today();
            this.pay_date = this.get_today();

            this.$root.root_validate_errors = [];

            // this.get_all_data();
            bus.$on('update_orders', (data) => {
                this.get_all_data()
            });

            bus.$on(this.confirm_delete_name, (data) => {
                // alert(data);
                if (data == "true") {
                    this.delete_item();

                } else {
                    this.status_form = 0;
                }
            });
        }, watch: {
            'check_all_exit': function () {
                if (this.check_all_exit) {
                    this.id_checkbox_items = [];

                    this.items_buy.forEach((val) => {
                        this.id_checkbox_items.push(val.MasterId);
                    });
                } else {
                    this.id_checkbox_items = [];
                }
            },
            '$route.params.person_id': function () {
                // this.get_all_data();
            },
            'start_date': function () {
                this.get_all_data();
            },
            'end_date': function () {
                this.get_all_data();
            }
        },
        methods: {
            get_total_price(item) {
                var total_price = 0
                item.details.forEach((val) => {
                    total_price = total_price + (val.price * val.qty)
                });
                return total_price;
            },
            get_all_data() {
                this.get_lists_buy();

            },
            table_row_clicked(item, index) {

                this.table_clicks++;
                if (this.table_clicks == 1) {
                    this.table_clicks_timer = setTimeout(() => {
                        // this.result.push(event.type);
                        this.table_clicks = 0
                    }, 500);
                } else if (this.table_clicks > 1) {
                    clearTimeout(this.table_clicks_timer);
                    this.selected_factor = item.details;
                    this.selected_master = item;
                    this.show_factor_detail = true;
                    this.status_form = item.masterId;
                }

            },
            accept_factor() {
                var self = this;

                var array = [];

                var validate = true;
                this.selected_factor.forEach((val) => {
                    var obj = {
                        SupplierId: this.selected_master.supplierId,
                        OrderFactorId: val.orderMasterId,
                        OrderDetailId: val.orderDetailId,
                        PlaceId: val.placeId,
                        ProductId: val.productId,
                        Qty: val.qty,
                        Price: val.price,
                        Vat: val.vat,
                        PaymentDate: this.pay_date,
                        Discount: val.off,
                        TotalPrice: val.qty * val.price,
                        Summary: val.summary,
                    };
                    if (obj.price == '' || obj.price == 0) {
                        validate = false;
                    }
                    if (obj.Vat == null || obj.Vat == "") {
                        obj.Vat = 0;
                    }
                    if (obj.Discount == null || obj.Discount == '') {
                        obj.Discount = 0;
                    }
                    array.push(obj);
                });

                console.log(array);
                if (validate == false) {
                    this.$root.modal_component.show_validate_errors(["تمامی فیلد ها را تکمیل کنید"])
                    return false;
                }
                // return false;
                const formData = new FormData();
                var url = "AddAcceptFactorPayment";
                formData.append("input", JSON.stringify(array));


                // formData.append("id", 1);

                axios.post(url, formData, {}).then(function (response) {

                    var content_data = response.data;

                    if (content_data.statusCode == 0) {
                        self.get_lists_buy();
                        self.$root.modal_component.show_api_response_modals(response);
                        self.show_factor_detail = false
                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                    }

                })
                    .catch(function (error) {
                        console.log(error);
                    });


            },
            get_lists_buy() {
                var self = this;


                const formData = new FormData();
                var url = "GetPurchaseOrderPreFactors";
                formData.append("docType", 1);
                if (self.$route.params.person_id != null) {
                    formData.append("PersonId", self.$route.params.person_id);

                } else {
                    formData.append("PersonId", 0);
                }
                formData.append("FirstDate", self.start_date);
                formData.append("SecondDate", self.end_date);

                // formData.append("id", 1);

                axios.post(url, formData, {}).then(function (response) {

                    var content_data = response.data;

                    if (content_data.statusCode == 0) {
                        // self.items_buy = content_data.data.map((item, row_id) => {
                        //   return {...item, row_id}
                        //
                        // });
                        var factors = content_data.data;
                        // factors = factors.filter(x => x.isAccept == 1)
                        self.items_buy = factors;
                        factors.forEach((val) => {
                            val.details.forEach((val2) => {

                                val2.supplierName = val.supplierName;
                                // val2.supplier_list = [{userName: val2.supplierName, userId: val2.supplierId}]
                                // self.items_buy.push(val2)
                            });
                        });

                        // setTimeout(() => {
                        //   var factors = content_data.data;
                        //   factors = factors.filter(x => x.isAccept == 0)
                        //   self.items_buy = [];
                        //   factors.forEach((val) => {
                        //     val.details.forEach((val2) => {
                        //
                        //       val2.suuplier_sync = true;
                        //       val2.supplier_list = [{userName: val2.supplierName, userId: val2.supplierId}]
                        //       self.items_buy.push(val2)
                        //     });
                        //   });


                        // }, 1000);

                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                    }

                })
                    .catch(function (error) {
                        console.log(error);
                    });

            },

            Finalize(item) {
                var self = this;


                const formData = new FormData();

                var url = "AddFactorToFinal";

                formData.append("id", item.recId);

                axios.post(url, formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    self.$root.modal_component.show_api_response_modals(response);

                    if (content_data.statusCode == 0) {
                        item.statusId = 1;
                    } else {
                        // self.$root.modal_component.show_danger_modal('خطا', content_data.message);

                    }

                })
                    .catch(function (error) {
                        console.log(error);
                    });

            },


        },

    }

</script>
